import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import CSVFeedbackTable from "./CSVFeedbackTable";
import { useSelector, useDispatch } from "react-redux";

import {
  resetBulk,
  selectProducts,
  fetchProducts,
} from "../products/productsSlice";

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#D86D7E",
    color: "#FFF",
    "&:hover": {
      opacity: 0.9,
      backgroundColor: "#D86D7E",
    },
    // fontWeight: 'bold',
  },
}))(Button);

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function BottomBar() {
  const [open, setOpen] = React.useState(false);
  const dispatch = useDispatch();
  let jwtToken = localStorage.getItem("coreToken");

  const { feedback, bulkDetails, bulkStatus, lastQuery } =
    useSelector(selectProducts);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleClear = () => {
    dispatch(fetchProducts({ token: jwtToken, query: lastQuery }));
    dispatch(resetBulk());
    setOpen(false);
  };

  const getFailureCount = (failuresList) => {
    let count = 0;
    failuresList.forEach((failure) => {
      if (failure.reason !== "success") {
        count += 1;
      }
    });
    return count;
  };

  return (
    <div>
      <div style={{ display: "flex", fontSize: 18, alignItems: "center" }}>
        {bulkStatus === "uploading" ? (
          <div>{bulkDetails.name} upload in progress</div>
        ) : bulkStatus === "success" ? (
          <div>{bulkDetails.name} upload completed successfully</div>
        ) : bulkStatus === "success with errors" ? (
          <div>{bulkDetails.name} upload completed with errors</div>
        ) : bulkStatus === "errors" ? (
          <div>{bulkDetails.name} upload failed</div>
        ) : (
          <div></div>
        )}
        {bulkStatus === "success with errors" || bulkStatus === "error" ? (
          <Button
            style={{ marginLeft: 24, marginRight: 16 }}
            // variant="outlined"
            variant="contained"
            color="secondary"
            onClick={handleClickOpen}
          >
            Error Report{" "}
          </Button>
        ) : bulkStatus === "success" ? (
          <Button
            style={{ marginLeft: 24, marginRight: 16 }}
            variant="outlined"
            color="primary"
            onClick={handleClear}
          >
            Clear Message{" "}
          </Button>
        ) : (
          <div></div>
        )}
      </div>

      <Dialog
        id="feedback-dialog"
        fullWidth={true}
        maxWidth={"lg"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <div style={{ fontWeight: "bold", fontSize: 24 }}>
            Error report for {bulkDetails.name}
          </div>
        </DialogTitle>
        <DialogContent style={{ padding: 24, paddingBottom: 48 }} dividers>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 24,
            }}
          >
            <div>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                Status:{" "}
                <span style={{ fontWeight: "normal" }}>{feedback.status}</span>
              </div>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                Success Count:{" "}
                <span style={{ fontWeight: "normal" }}>
                  {feedback.successCount}
                </span>
              </div>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                Error Count:{" "}
                <span style={{ fontWeight: "normal" }}>
                  {feedback.failures ? getFailureCount(feedback.failures) : ""}
                </span>
              </div>
            </div>
            <div>
              {/* <ColorButton onClick={handleUpload}>New Upload</ColorButton> */}
            </div>
          </div>

          <CSVFeedbackTable data={feedback.failures} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClear} color="primary">
            Clear Report
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
